import { render } from "./JournalCard.vue?vue&type=template&id=dc935c38&scoped=true"
import script from "./JournalCard.vue?vue&type=script&lang=js"
export * from "./JournalCard.vue?vue&type=script&lang=js"

import "./JournalCard.vue?vue&type=style&index=0&id=dc935c38&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc935c38"]])

export default __exports__